/* eslint-disable no-confusing-arrow */
import styled from 'styled-components'

export const ModalBackdrop = styled.div`
  background-color: ${({ theme }) => theme.colors.black}70;

  display: flex;
  justify-content: center;
  align-items: center;

  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  z-index: 10;

  transition: opacity 0.3s ease, visibility 0.3s ease;
  opacity: ${({ isOpen }) => (isOpen ? 1 : 0)};
  visibility: ${({ isOpen }) => (isOpen ? 'visible' : 'hidden')};
  pointer-events: ${({ isOpen }) => (isOpen ? 'all' : 'none')};
`

export const ModalWrapper = styled.div`
  padding: 0;
  color: ${({ theme }) => theme.colors.primary};
`
export const ModalContainer = styled.div`
  padding: 0;
  background-color: ${({ theme }) => theme.colors.background};
  border: 1px solid ${({ theme }) => `${theme.colors.secondary}80`};
  border-radius: 15px;

  transition: opacity 0.3s ease, transform 0.3s ease;
  opacity: ${({ isOpen }) => (isOpen ? 1 : 0)};
  transform: ${({ isOpen }) => (isOpen ? 'translateY(0) scale(1)' : 'translateY(20px) scale(0.95)')};
`
